import React, { FC } from 'react';
import { avatarIds } from '#config';
import AvatarItem from '#modules/profileSelection/avatarlist/AvatarItem';

type Props = {
  title?: string;
  onKeyPress?: (e) => void;
  onSelect: (id: number) => void;
  selectedAvatarAssetId: number;
};

const AvatarList: FC<Props> = ({
  title,
  onKeyPress,
  onSelect,
  selectedAvatarAssetId,
}) => {
  return (
    <div className="tw-flex tw-flex-col" aria-labelledby={title} role="group">
      <strong className="tw-sr-only" id={title}>
        {title}
      </strong>
      <ul
        className="tw-flex tw-flex-wrap tw-gap-8 tw-mx-auto tw-justify-center large-up:tw-grid large-up:tw-grid-cols-6"
        data-testid="profile-avatar-list"
      >
        {avatarIds.map((avatarAssetId) => {
          return (
            <AvatarItem
              key={avatarAssetId}
              id={avatarAssetId}
              avatarAssetId={avatarAssetId}
              selected={avatarAssetId === selectedAvatarAssetId}
              onKeyPress={onKeyPress}
              onSelect={onSelect}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default AvatarList;
